export const categories = [
  {
    slug: 'dianying',
    name: '电影',
    icon: 'ri-movie-2-line',
    description: '最新最热的电影大片，院线热映与经典佳作尽在掌握',
  },
  {
    slug: 'dianshiju',
    name: '电视剧',
    icon: 'ri-tv-2-line',
    description: '热播电视剧全集，都市情感、古装玄幻、悬疑推理一网打尽',
  },
  {
    slug: 'zongyi',
    name: '综艺',
    icon: 'ri-live-line',
    description: '热门综艺节目，搞笑、音乐、真人秀等精彩内容不间断',
  },
  {
    slug: 'dongman',
    name: '动漫',
    icon: 'ri-ghost-smile-line',
    description: '国漫日漫精选，热血、治愈、冒险多种题材任你选择',
  },
  {
    slug: 'jilupian',
    name: '纪录片',
    icon: 'ri-earth-line',
    description: '高品质纪录片，自然、人文、历史、科技视野触手可及',
  },
  {
    slug: 'tiyu',
    name: '体育',
    icon: 'ri-basketball-line',
    description: '精彩体育赛事集锦，足球、篮球、电竞等热门项目全覆盖',
  },
];

export const videoData = [
  {
    id: 1,
    title: '流浪地球3：星辰大海',
    category: 'dianying',
    thumbnail: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20movie%20scene%20with%20massive%20spaceship%20in%20deep%20space%2C%20nebula%20colors%2C%20cinematic%20lighting%2C%20dramatic%20composition%2C%20warm%20orange%20and%20teal%20tones%2C%20film%20poster%20aesthetic%2C%20clean%20minimal%20background&width=800&height=450&seq=video-thumb-01&orientation=landscape',
    duration: '02:18:45',
    views: '1280万',
    rating: 9.2,
    description: '人类文明在浩瀚宇宙中寻找新的家园，面对未知的挑战与机遇，勇气与智慧将决定命运的方向。',
  },
  {
    id: 2,
    title: '繁华似锦',
    category: 'dianshiju',
    thumbnail: 'https://readdy.ai/api/search-image?query=Modern%20Chinese%20urban%20drama%20scene%20with%20stylish%20couple%20walking%20through%20city%20streets%20at%20sunset%2C%20warm%20golden%20lighting%2C%20cinematic%20look%2C%20fashionable%20outfits%2C%20romantic%20atmosphere%2C%20clean%20background&width=800&height=450&seq=video-thumb-02&orientation=landscape',
    duration: '45:30',
    views: '986万',
    rating: 8.8,
    description: '在繁华都市中追寻梦想与爱情，每一个选择都是一场命运的赌注。',
  },
  {
    id: 3,
    title: '笑傲江湖·第十季',
    category: 'zongyi',
    thumbnail: 'https://readdy.ai/api/search-image?query=Vibrant%20Chinese%20variety%20show%20stage%20with%20colorful%20lights%20and%20cheerful%20hosts%2C%20energetic%20atmosphere%2C%20studio%20setting%20with%20audience%2C%20warm%20spotlight%20effects%2C%20entertainment%20show%20aesthetic&width=800&height=450&seq=video-thumb-03&orientation=landscape',
    duration: '01:32:15',
    views: '2150万',
    rating: 9.5,
    description: '顶尖喜剧人齐聚一堂，爆笑不断惊喜连连，为您带来最纯粹的欢乐时光。',
  },
  {
    id: 4,
    title: '灵笼·终章',
    category: 'dongman',
    thumbnail: 'https://readdy.ai/api/search-image?query=Futuristic%20Chinese%20anime%20scene%20with%20mecha%20and%20characters%20in%20post-apocalyptic%20world%2C%20dramatic%20lighting%2C%20detailed%20illustration%20style%2C%20warm%20orange%20sky%2C%20epic%20composition&width=800&height=450&seq=video-thumb-04&orientation=landscape',
    duration: '01:48:00',
    views: '756万',
    rating: 9.1,
    description: '末世之下，人类在绝境中寻找希望之光，科技与人性的碰撞震撼人心。',
  },
  {
    id: 5,
    title: '地球脉动：海洋深处',
    category: 'jilupian',
    thumbnail: 'https://readdy.ai/api/search-image?query=Stunning%20underwater%20documentary%20scene%20with%20colorful%20coral%20reef%20and%20diverse%20marine%20life%2C%20crystal%20clear%20ocean%20water%2C%20sunlight%20rays%20penetrating%20deep%20blue%2C%20nature%20photography%20aesthetic&width=800&height=450&seq=video-thumb-05&orientation=landscape',
    duration: '00:52:30',
    views: '632万',
    rating: 9.7,
    description: '潜入深海世界，探索地球上最神秘、最壮丽的生态系统。',
  },
  {
    id: 6,
    title: 'NBA精彩集锦：季后赛巅峰对决',
    category: 'tiyu',
    thumbnail: 'https://readdy.ai/api/search-image?query=Exciting%20basketball%20game%20moment%20with%20player%20dunking%20dramatically%2C%20arena%20filled%20with%20cheering%20crowd%2C%20dynamic%20sports%20photography%2C%20warm%20stadium%20lights%2C%20action-packed%20composition&width=800&height=450&seq=video-thumb-06&orientation=landscape',
    duration: '00:28:45',
    views: '890万',
    rating: 9.0,
    description: '季后赛最燃瞬间，每一球都让人热血沸腾，篮球的魅力在此刻绽放。',
  },
  {
    id: 7,
    title: '长安十二时辰：风起云涌',
    category: 'dianying',
    thumbnail: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20Tang%20dynasty%20city%20scene%20at%20sunset%20with%20traditional%20architecture%2C%20dramatic%20sky%2C%20period%20costumes%2C%20cinematic%20lighting%2C%20historical%20film%20aesthetic%2C%20warm%20golden%20tones&width=800&height=450&seq=video-thumb-07&orientation=landscape',
    duration: '02:05:30',
    views: '1650万',
    rating: 9.4,
    description: '繁华盛唐，暗流涌动。一场关乎长安城安危的惊天阴谋正在悄然展开。',
  },
  {
    id: 8,
    title: '星辰大海',
    category: 'dianshiju',
    thumbnail: 'https://readdy.ai/api/search-image?query=Romantic%20Chinese%20drama%20scene%20with%20couple%20standing%20by%20seaside%20at%20sunset%2C%20soft%20golden%20light%2C%20emotional%20atmosphere%2C%20cinematic%20composition%2C%20beautiful%20ocean%20view&width=800&height=450&seq=video-thumb-08&orientation=landscape',
    duration: '42:18',
    views: '756万',
    rating: 8.5,
    description: '两位年轻人在追逐梦想的道路上相遇相知，共同书写属于他们的浪漫篇章。',
  },
  {
    id: 9,
    title: '脱口秀大会·第八季',
    category: 'zongyi',
    thumbnail: 'https://readdy.ai/api/search-image?query=Comedy%20stage%20show%20with%20single%20performer%20under%20spotlight%2C%20modern%20studio%20setting%2C%20warm%20intimate%20atmosphere%2C%20entertaining%20vibe%2C%20clean%20minimalist%20stage%20design&width=800&height=450&seq=video-thumb-09&orientation=landscape',
    duration: '01:25:40',
    views: '1820万',
    rating: 9.3,
    description: '新一代脱口秀演员用幽默洞察生活，笑中带泪，引发深度共鸣。',
  },
  {
    id: 10,
    title: '深海大冒险',
    category: 'dongman',
    thumbnail: 'https://readdy.ai/api/search-image?query=Colorful%20animated%20underwater%20adventure%20scene%20with%20cute%20characters%20exploring%20ocean%2C%20vibrant%20coral%20colors%2C%20magical%20atmosphere%2C%20warm%20sunlight%20filtering%20through%20water%2C%20family-friendly%20animation%20style&width=800&height=450&seq=video-thumb-10&orientation=landscape',
    duration: '01:35:20',
    views: '520万',
    rating: 8.9,
    description: '勇敢的小探险家们潜入深海，开启一段充满惊喜与感动的奇妙旅程。',
  },
  {
    id: 11,
    title: '大国重器：航天奇迹',
    category: 'jilupian',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20space%20station%20orbiting%20earth%20with%20stunning%20view%20of%20planet%2C%20technological%20achievement%2C%20clean%20space%20background%20with%20stars%2C%20documentary%20photography%20style%2C%20inspiring%20composition&width=800&height=450&seq=video-thumb-11&orientation=landscape',
    duration: '00:48:20',
    views: '445万',
    rating: 9.6,
    description: '见证中国航天事业的辉煌成就，探索宇宙的无限可能与人类的伟大梦想。',
  },
  {
    id: 12,
    title: '世界杯经典回顾',
    category: 'tiyu',
    thumbnail: 'https://readdy.ai/api/search-image?query=Thrilling%20soccer%20match%20moment%20with%20player%20celebrating%20goal%2C%20packed%20stadium%20with%20passionate%20fans%2C%20dramatic%20sports%20photography%2C%20green%20field%20under%20bright%20lights%2C%20epic%20competition%20atmosphere&width=800&height=450&seq=video-thumb-12&orientation=landscape',
    duration: '01:15:00',
    views: '980万',
    rating: 9.2,
    description: '回顾世界杯历史上最激动人心的瞬间，重温那些让人热泪盈眶的经典时刻。',
  },
  {
    id: 13,
    title: '无间道：暗影重生',
    category: 'dianying',
    thumbnail: 'https://readdy.ai/api/search-image?query=Noir%20style%20crime%20thriller%20scene%20with%20two%20men%20in%20dark%20alley%2C%20dramatic%20shadows%2C%20rain-slicked%20streets%2C%20neon%20reflections%2C%20tense%20atmosphere%2C%20cinematic%20lighting%2C%20warm%20amber%20accents&width=800&height=450&seq=video-thumb-13&orientation=landscape',
    duration: '02:12:00',
    views: '1100万',
    rating: 9.0,
    description: '黑白之间的界限逐渐模糊，信任与背叛在一念之间，暗影中的博弈一触即发。',
  },
  {
    id: 14,
    title: '青春斗',
    category: 'dianshiju',
    thumbnail: 'https://readdy.ai/api/search-image?query=Youthful%20Chinese%20campus%20drama%20scene%20with%20group%20of%20young%20students%20laughing%20together%2C%20sunlit%20university%20campus%2C%20warm%20and%20bright%20atmosphere%2C%20fresh%20natural%20lighting%2C%20coming-of-age%20aesthetic&width=800&height=450&seq=video-thumb-14&orientation=landscape',
    duration: '43:25',
    views: '678万',
    rating: 8.4,
    description: '大学校园里，一群年轻人用热血和汗水书写着属于他们的青春故事。',
  },
  {
    id: 15,
    title: '动物世界：草原之王',
    category: 'jilupian',
    thumbnail: 'https://readdy.ai/api/search-image?query=Majestic%20lion%20pride%20on%20African%20savanna%20during%20golden%20sunset%2C%20dramatic%20wildlife%20photography%2C%20warm%20earthy%20tones%2C%20vast%20grassland%20landscape%2C%20nature%20documentary%20aesthetic&width=800&height=450&seq=video-thumb-15&orientation=landscape',
    duration: '00:55:10',
    views: '389万',
    rating: 9.5,
    description: '跟随镜头走进非洲大草原，近距离观察狮子家族的生存智慧与壮丽史诗。',
  },
  {
    id: 16,
    title: '电竞巅峰：LPL春季赛',
    category: 'tiyu',
    thumbnail: 'https://readdy.ai/api/search-image?query=Esports%20arena%20with%20massive%20LED%20screens%20and%20excited%20crowd%2C%20professional%20gaming%20competition%2C%20colorful%20stage%20lighting%2C%20intense%20competitive%20atmosphere%2C%20modern%20venue%20design&width=800&height=450&seq=video-thumb-16&orientation=landscape',
    duration: '03:45:30',
    views: '1560万',
    rating: 9.1,
    description: '顶级电竞战队巅峰对决，每一秒的操作都牵动着千万观众的心。',
  },
];

export const articles = [
  {
    id: 1,
    title: '2026年最值得期待的十部国产大片',
    slug: '2026-top-10-chinese-movies',
    category: '电影资讯',
    excerpt: '2026年国产电影市场有哪些值得期待的作品？我们为你盘点今年最受关注的十部即将上映的国产大片。',
    content: `2026年是中国电影产业持续蓬勃发展的一年。随着电影制作技术的不断进步和优秀人才的涌现，今年将有众多备受期待的国产大片与观众见面。

## 科幻巨制引领潮流

《流浪地球3：星辰大海》无疑是今年最受关注的电影之一。作为中国科幻电影的标杆之作，该系列第三部将继续探索人类在宇宙中的命运。导演表示，本片在视觉效果上将实现质的飞跃，同时故事深度也将进一步拓展。

## 历史题材精品迭出

《长安十二时辰：风起云涌》将观众带回繁花似锦的盛唐时代。影片以宏大的历史视角和细腻的人物刻画，展现了一段惊心动魄的长安故事。精良的制作和考究的服装道具，让人仿佛穿越千年。

## 犯罪悬疑再攀高峰

《无间道：暗影重生》延续了经典的警匪题材，但以全新的视角和叙事手法重新诠释了这一类型。影片在保持紧张刺激的同时，深入探讨了人性的复杂与多面。

## 动画电影百花齐放

国产动画电影在过去几年取得了令人瞩目的成绩，《深海大冒险》作为新一代动画力作，将以更加成熟的叙事和惊艳的画面，为观众带来一场视听盛宴。

无论你喜欢什么类型，2026年的国产电影都值得期待。让我们一起走进电影院，支持中国电影的蓬勃发展！`,
    coverImage: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20theater%20interior%20with%20red%20seats%20and%20large%20illuminated%20screen%2C%20warm%20ambient%20lighting%2C%20elegant%20and%20inviting%20atmosphere%2C%20premium%20cinema%20experience%2C%20clean%20and%20modern%20design&width=1200&height=600&seq=article-cover-01&orientation=landscape',
    publishedAt: '2026-07-28',
    readTime: '8分钟',
    author: '影视观察员',
    tags: ['电影', '国产电影', '2026', '影评'],
  },
  {
    id: 2,
    title: '短视频时代，长视频平台如何突围？',
    slug: 'long-video-platform-strategy',
    category: '行业观察',
    excerpt: '在短视频大行其道的今天，长视频平台面临着怎样的挑战与机遇？我们深度分析行业现状与未来趋势。',
    content: `短视频平台的崛起给传统长视频平台带来了巨大的冲击。用户的注意力越来越碎片化，如何在这个时代保持竞争力，成为每个长视频平台必须面对的问题。

## 内容为王不变

无论媒介形式如何变化，优质内容始终是吸引用户的核心。长视频平台需要在内容质量上持续投入，打造差异化竞争优势。

## 技术创新驱动体验升级

4K/8K超高清、AI推荐算法、沉浸式观影体验等技术创新，正在重新定义用户的观看方式。

## 社区化运营增强黏性

弹幕文化、评论区互动、用户共创等社区化运营策略，能够有效增强用户黏性和平台归属感。

## 多元化商业模式探索

会员订阅、单片付费、广告植入、IP衍生开发等多元化商业模式，为长视频平台提供了更广阔的发展空间。

长视频平台的未来不在于与短视频直接竞争，而在于发挥自身优势，为用户提供不可替代的价值。`,
    coverImage: 'https://readdy.ai/api/search-image?query=Modern%20streaming%20platform%20interface%20design%20concept%20with%20multiple%20video%20thumbnails%2C%20clean%20UI%20design%2C%20technology%20and%20media%20theme%2C%20warm%20ambient%20lighting%2C%20minimalist%20workspace%20setting&width=1200&height=600&seq=article-cover-02&orientation=landscape',
    publishedAt: '2026-07-25',
    readTime: '6分钟',
    author: '行业分析师',
    tags: ['行业趋势', '视频平台', '短视频', '长视频'],
  },
  {
    id: 3,
    title: '如何选择适合自己的在线视频平台？',
    slug: 'how-to-choose-video-platform',
    category: '使用指南',
    excerpt: '面对众多在线视频平台，该如何选择最适合自己的那一个？我们从内容、体验、价格等维度为你全面解析。',
    content: `市面上的在线视频平台琳琅满目，如何选择最适合自己的平台，成为不少用户的困扰。本文将从多个维度帮助你做出明智的选择。

## 内容库是否丰富

不同平台有着不同的内容侧重。有的平台电影资源丰富，有的在电视剧上有优势，还有的专注于动漫或纪录片。选择前，先看看平台的内容是否匹配你的观影偏好。

## 用户体验是否流畅

页面加载速度、视频清晰度、播放流畅度、操作便捷性等，都是影响观影体验的重要因素。好的平台应该让你可以顺畅地找到并观看想看的视频。

## 是否真的免费

有些平台标榜免费，但实际上充斥着大量广告或者限制观看。选择一个真正免费的、体验良好的平台至关重要。

## 设备兼容性

优秀的平台应该支持PC端、移动端、平板等多种设备，让你随时随地都能流畅观看。

黄瓜视频网页版正是这样一款满足以上所有需求的平台——完全免费、无需下载、内容丰富、体验流畅。`,
    coverImage: 'https://readdy.ai/api/search-image?query=Person%20comfortably%20watching%20videos%20on%20laptop%20in%20cozy%20living%20room%20setting%2C%20warm%20evening%20lighting%2C%20relaxed%20atmosphere%2C%20modern%20home%20interior%2C%20lifestyle%20photography%20style&width=1200&height=600&seq=article-cover-03&orientation=landscape',
    publishedAt: '2026-07-20',
    readTime: '5分钟',
    author: '产品体验官',
    tags: ['使用指南', '视频平台', '选择攻略', '在线观看'],
  },
  {
    id: 4,
    title: '国产动漫崛起：从追赶到引领的十年',
    slug: 'chinese-animation-rise',
    category: '动漫文化',
    excerpt: '过去十年，国产动漫经历了从量变到质变的飞跃。我们回顾这段不平凡的旅程，展望更加精彩的未来。',
    content: `十年前，国产动漫还处于学习和模仿的阶段。如今，一批优秀的国产动漫作品不仅在国内收获了大量粉丝，更开始走向世界舞台。

## 技术突破是基础

随着3D动画技术的成熟和2D动画人才的积累，国产动漫在画面表现力上取得了质的飞跃。从《灵笼》到《深海大冒险》，每一部作品都在技术层面实现了突破。

## 讲好中国故事

国产动漫最大的优势在于能够讲述属于中国人自己的故事。无论是神话传说还是现代都市，深厚的文化底蕴为创作提供了取之不尽的灵感源泉。

## 产业生态日趋完善

从人才培养到制作发行，从IP开发到衍生品市场，国产动漫的产业生态正在不断完善，为可持续发展提供了坚实基础。

## 走向世界的机遇

随着中国文化影响力的提升，国产动漫正在获得越来越多海外观众的认可，这是属于中国动漫的黄金时代。`,
    coverImage: 'https://readdy.ai/api/search-image?query=Beautiful%20Chinese%20animation%20art%20style%20showcasing%20traditional%20and%20modern%20fusion%2C%20vibrant%20colors%2C%20artistic%20illustration%2C%20cultural%20elements%2C%20warm%20and%20inspiring%20composition&width=1200&height=600&seq=article-cover-04&orientation=landscape',
    publishedAt: '2026-07-15',
    readTime: '7分钟',
    author: '动漫评论家',
    tags: ['国产动漫', '动漫产业', '国漫崛起', '文化出海'],
  },
  {
    id: 5,
    title: '纪录片推荐：不可错过的十部神作',
    slug: 'top-10-documentaries',
    category: '观影推荐',
    excerpt: '我们精心挑选了十部不可错过的纪录片神作，涵盖自然、历史、科技等多个领域，每一部都值得反复观看。',
    content: `纪录片是通往真实世界的一扇窗。一部优秀的纪录片，能够带你领略从未见过的风景，了解不为人知的故事，启发你对世界的重新思考。

## 自然类纪录片

《地球脉动：海洋深处》以令人窒息的画面，展现了海洋世界的神奇与壮美。《动物世界：草原之王》则将镜头对准非洲大草原上的顶级掠食者，呈现生命的坚韧与温柔。

## 科技类纪录片

《大国重器：航天奇迹》记录了中国航天事业的辉煌成就，每一帧画面都让人热血沸腾。

## 人文类纪录片

优秀的人文纪录片能够跨越时空，连接不同文化背景下的人们，引发深层的情感共鸣与思考。

这些纪录片不仅仅是影像的记录，更是人类智慧与情感的结晶。希望这份推荐清单能为你打开一扇通往精彩世界的大门。`,
    coverImage: 'https://readdy.ai/api/search-image?query=Artistic%20arrangement%20of%20documentary%20film%20posters%20and%20camera%20equipment%20on%20wooden%20desk%2C%20warm%20vintage%20lighting%2C%20creative%20workspace%2C%20filmmaker%20aesthetic%2C%20inspirational%20atmosphere&width=1200&height=600&seq=article-cover-05&orientation=landscape',
    publishedAt: '2026-07-10',
    readTime: '6分钟',
    author: '纪录片爱好者',
    tags: ['纪录片', '推荐清单', '自然', '科技'],
  },
  {
    id: 6,
    title: '在线视频画质科普：从标清到8K',
    slug: 'video-quality-guide',
    category: '技术科普',
    excerpt: '标清、高清、超清、蓝光、4K、8K...这些视频画质到底有什么区别？一文带你彻底搞懂。',
    content: `在观看在线视频时，你是否经常看到标清、高清、超清、蓝光等画质选项？这些术语背后代表着不同的分辨率和技术标准。

## 从像素说起

视频画面由无数个像素点组成。分辨率就是画面中像素点的数量，分辨率越高，画面越清晰，细节越丰富。

## 常见画质标准

- 标清（SD）：720x576像素，适合小屏幕观看
- 高清（HD）：1280x720像素，基本的高清标准
- 全高清（FHD）：1920x1080像素，目前最主流的画质
- 超高清（4K）：3840x2160像素，四倍于全高清的清晰度
- 8K：7680x4320像素，代表当前最高画质水平

## 选择合适的画质

画质越高，需要的网络带宽也越大。根据自己的网络环境和设备屏幕，选择最合适的画质才能获得最佳观影体验。

黄瓜视频网页版支持多档画质自动适配，让你在不同网络环境下都能流畅观看。`,
    coverImage: 'https://readdy.ai/api/search-image?query=Abstract%20digital%20art%20representing%20video%20resolution%20and%20pixels%2C%20colorful%20geometric%20patterns%2C%20technology%20concept%2C%20clean%20minimalist%20design%2C%20warm%20gradient%20background&width=1200&height=600&seq=article-cover-06&orientation=landscape',
    publishedAt: '2026-07-05',
    readTime: '4分钟',
    author: '技术编辑',
    tags: ['技术科普', '视频画质', '分辨率', '在线观看'],
  },
];

export const stats = [
  { icon: 'ri-user-line', value: '5000万+', label: '注册用户' },
  { icon: 'ri-movie-line', value: '10万+', label: '视频资源' },
  { icon: 'ri-eye-line', value: '30亿+', label: '月播放量' },
  { icon: 'ri-thumb-up-line', value: '98.5%', label: '用户好评率' },
];

export const faqs = [
  {
    question: '黄瓜视频网页版需要下载安装吗？',
    answer: '完全不需要！黄瓜视频网页版是一款纯在线视频平台，直接在浏览器中打开即可使用，无需下载任何软件或插件。支持Chrome、Edge、Safari、Firefox等主流浏览器。',
  },
  {
    question: '观看视频需要注册账号吗？',
    answer: '不需要！黄瓜视频网页版坚持免费开放的原则，用户无需注册即可直接观看所有视频内容。如果您希望收藏视频或订阅频道，可以选择注册账号获得更多个性化功能。',
  },
  {
    question: '支持哪些设备访问？',
    answer: '黄瓜视频网页版全面支持PC端（Windows/Mac/Linux）、移动端（iOS/Android手机和平板）以及智能电视浏览器访问。页面会自动适配不同屏幕尺寸，确保您在任何设备上都能获得流畅的观看体验。',
  },
  {
    question: '视频画质怎么样？加载速度快吗？',
    answer: '平台采用先进的视频编码和CDN加速技术，提供从标清到4K超高清的多档画质选择。视频会根据您的网络环境自动匹配最佳画质，确保流畅播放不卡顿。',
  },
  {
    question: '平台上的视频资源多久更新一次？',
    answer: '我们每日更新海量视频内容，热门电影、电视剧、综艺节目将在第一时间上线。纪录片和动漫板块也保持每周更新的频率，确保您总能看到最新最热的内容。',
  },
  {
    question: '黄瓜视频网页版是免费的吗？',
    answer: '是的，完全免费！黄瓜视频网页版致力于为用户提供免费、优质的在线视频观看体验。所有视频内容均可免费观看，无隐藏收费，无强制广告。',
  },
];